import { render, staticRenderFns } from "./ProductModelCreateEdit.vue?vue&type=template&id=3a33b9ad&scoped=true&"
import script from "./ProductModelCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ProductModelCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductModelCreateEdit.vue?vue&type=style&index=0&id=3a33b9ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a33b9ad",
  null
  
)

export default component.exports